import React, { useState } from 'react';
import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate
} from "react-router-dom";
import SignUp from './Auth/SignUp';
import Login from './Auth/Login';
import SideNav from './Components/SideNav';
import TopNav from './Components/TopNav';
import DashboardHome from './Screens/Dashboard/DashboardHome';
import { SelectedLanguagesContext } from './Context/SelectedLanguagesContext';
import BottomNav from './Components/BottomNav';
import Overview from './Screens/Leads/Overview';
import Finance from './Screens/Finance/Finance';
import Details from './Screens/Finance/Details';
import Tasks from './Screens/Tasks/Tasks';
import Settings from './Screens/Settings/Settings';
import Requirements from './Screens/Leads/Requirements';
import Concepts from './Screens/Leads/Concepts';
import Documents from './Screens/Leads/Documents';
import BOQ from './Screens/Leads/BOQ';
import Records from './Screens/Leads/Records';
import Leads from './Screens/Leads/Leads';
import Projects from './Screens/Projects/Projects';
import BasicDetails from './Screens/DesignQuiz/BasicDetails';
import QuizHeader from './Components/QuizHeader';
import ProjectDetails from './Screens/DesignQuiz/ProjectDetails';
import DesignStyle from './Screens/DesignQuiz/DesignStyle';
import SpaceConfig from './Screens/DesignQuiz/SpaceConfig';
import CostPackage from './Screens/DesignQuiz/CostPackage';
import UploadLayout from './Screens/DesignQuiz/UploadLayout';

function App() {
  const location = useLocation()
  const [selectedLanguagesContext, setSelectedLanguagesContext] = useState([])

  return <React.Fragment>
      {location.pathname.includes('/dashboard') && <TopNav />}
      {location.pathname.includes('/dashboard') && <BottomNav />}
      <Routes>
        <Route
          path="/"
          element={<Navigate to="login" replace />}
        />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUp />} />

        <Route path="dashboard">
            <Route path="home" element={<DashboardHome />} />
            <Route path="finance" element={<Finance />} />
            <Route path="tasks" element={<Tasks />} />
            <Route path="settings" element={<Settings />} />
            <Route path="finance/details" element={<Details />} />

            <Route path="leads" element={<Leads />} />
            <Route path="leads/overview" element={<Overview />} />
            <Route path="leads/requirements" element={<Requirements />} />
            <Route path="leads/concepts" element={<Concepts />} />
            <Route path="leads/documents" element={<Documents />} />
            <Route path="leads/boq" element={<BOQ />} />
            <Route path="leads/records" element={<Records />} />

            <Route path="projects" element={<Projects />} />
            <Route path="projects/overview" element={<Overview />} />
            <Route path="projects/requirements" element={<Requirements />} />
            <Route path="projects/concepts" element={<Concepts />} />
            <Route path="projects/documents" element={<Documents />} />
            <Route path="projects/boq" element={<BOQ />} />
            <Route path="projects/records" element={<Records />} />
            <Route
              path=""
              element={<Navigate to="home" replace />}
            />
        </Route>

        <Route path="quiz">
            <Route path="basicdetails" element={<BasicDetails />} />
            <Route path="projectdetails" element={<ProjectDetails />} />
            <Route path="designstyle" element={<DesignStyle />} />
            <Route path="spaceconfig" element={<SpaceConfig />} />
            <Route path="costpackage" element={<CostPackage />} />
            <Route path="uploadlayout" element={<UploadLayout />} />
            <Route
              path=""
              element={<Navigate to="basicdetails" replace />}
            />
        </Route>

      </Routes>

    {/* {location.pathname.includes('/dashboard') && <React.Fragment>
      <SideNav />
      <TopNav />
      <div className="dashboard-main-container">
        <Routes>
          <Route path="dashboard">
            <Route path="home" element={<DashboardHome />} />
            <Route path="analytics" element={<DashboardAnalytics />} />
            <Route path="campaigns" element={<DashboardCampaigns />} />
            <Route path="integration" element={<DashboardIntegration />} />
            <Route path="settings" element={<DashboardSettings />} />
            <Route path="campaign-details" element={<CampaignDetails />} />
            <Route path="audience" element={<DashboardAudience />} />
            <Route path="group-details" element={<GroupDetails />} />
            <Route path="contact-details" element={<ContactDetails />} />
            <Route
              path=""
              element={<Navigate to="home" replace />}
            />
          </Route>
        </Routes>
      </div>
    </React.Fragment>} */}

  </React.Fragment>
}

export default App;
